import { z } from '@hono/zod-openapi'
import { idZ as organizationIdBaseZ } from './admin_organization_type'
import { roleLabelZ, roleZ } from './admin_type'

// id
// 予約ロールは admin_org_roles に実体を持たないため、ロール名を id として使う。
export const idZ = z
  .string()
  .openapi({ description: 'ロールID', example: 'uuid-1234' })
export type id = z.infer<typeof idZ>

// organizationId
// 予約ロールはどの組織にも属さないため null。
export const organizationIdZ = organizationIdBaseZ.nullable()
export type organizationId = z.infer<typeof organizationIdZ>

// role
export { roleZ }
export type role = z.infer<typeof roleZ>

// label
export const labelZ = roleLabelZ
export type label = z.infer<typeof labelZ>

// permissions
export const permissionsZ = z.record(z.string(), z.array(z.string())).openapi({
  description: 'リソース名 -> 許可する操作',
  example: { property: ['read'], ticket: ['read', 'update'] },
})
export type permissions = z.infer<typeof permissionsZ>

// createdAt
export const createdAtDateZ = z
  .date()
  .openapi({ example: '2024-01-01T00:00:00.000Z' })
export type createdAtDate = z.infer<typeof createdAtDateZ>

// updatedAt
export const updatedAtDateZ = z
  .date()
  .nullable()
  .openapi({ example: '2024-01-01T00:00:00.000Z' })
export type updatedAtDate = z.infer<typeof updatedAtDateZ>
